import axios from "axios";
import {getPrivateURL, getPublicURL} from "./core.service";
import AuthServices from "./auth.services";
import {applyAuthorizationHeader} from "./http-auth.service";

// axios.defaults.withCredentials = true;
applyAuthorizationHeader(axios);

const getAuthToken = () => {
  const token = localStorage.getItem("access_token");
  if (token && token !== "null" && token !== "undefined") {
    return token;
  }
  return "";
};

const getAuthHeaders = () => {
  const token = getAuthToken();
  if (!token) {
    return {};
  }
  return { Authorization: token };
};

export const getProcessList = () => {
  return axios.get(`${getPrivateURL()}processes`, { headers: getAuthHeaders() });
};
export const getProcessItem = (process_id) => {
  return axios.get(`${getPrivateURL()}processes/${process_id}`, { headers: getAuthHeaders() });
};
export const startSimulate = (process_id) => {
  return axios.post(`${getPublicURL()}processes/process_simulate/${process_id}`, null, {
    headers: getAuthHeaders(),
  });
};
export const rerunSimulate = (process_id) => {
  return axios.post(`${getPublicURL()}processes/rerun_simulate/${process_id}`, null, {
    headers: getAuthHeaders(),
  });
};
export const createDraft = () => {
    return axios.post(`${getPublicURL()}processes?device_id=${AuthServices.getDeviceId()}`, null, {
      headers: getAuthHeaders(),
    });
};
export const uploadData = (form_data) => {
    return axios.post(`${getPublicURL()}processes/upload_data`, form_data, {
        headers:
            {
                ...getAuthHeaders(),
                "Content-Type":"multipart/form-data",
            }} );
};
export const updateProcess = (process_id, data) => {
    return axios.put(`${getPrivateURL()}processes/${process_id}`, data, { headers: getAuthHeaders() });
};
export const removeProcess = (process_id) => {
    return axios.delete(`${getPrivateURL()}processes/${process_id}`, { headers: getAuthHeaders() });
};
export const disableProcess = (process_id) => {
    return axios.patch(`${getPrivateURL()}processes/${process_id}`, null, { headers: getAuthHeaders() });
};
  

const ProcessService = {
  getProcessList,
  getProcessItem,
  uploadData,
  startSimulate,
  rerunSimulate,
  createDraft,
  updateProcess,
  removeProcess,
  disableProcess,
};
export default ProcessService;
